import { Grid, IconButton, Paper, Theme, Collapse } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import Track from 'core/logger/track';
import router from 'next/router';
import React, { useEffect, useState } from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
import logger from 'core/logger/logger';
import AddToChrome from './AddToChrome';

const useStyles = makeStyles<Theme>((theme) => ({
  extensionUpsalePaper: {
    marginBottom: '8px',
    backgroundColor: theme.palette.primary.main,
    minHeight: '70px',
    padding: '16px 52px 16px 32px',
    position: 'relative',
    [theme.breakpoints.down(1250)]: {
      display: 'none',
    },
  },
  // pipe: {
  //   border: `1px solid ${theme.specialColors.WHITE_TEXT}`,
  //   margin: '0px 10px',
  // },
  content: {
    padding: '5px 0px',
    color: theme.palette.primary.contrastText,
    fontSize: '20px',
  },
  leftContent: {
    paddingRight: 16,
    borderRight: `2px solid ${theme.palette.primary.contrastText}`,
    fontWeight: 600,
  },
  rightContent: {
    paddingLeft: 24,
  },
  btnContainer: {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    borderRadius: '100px',
  },
  addToChromeBtn: {
    padding: '6px 20px',
  },
  closeIconButton: {
    position: 'absolute',
    padding: '0px',
    right: 5,
    top: 5,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  closeIcon: {
    fontSize: '1.25rem',
    color: theme.specialColors.MAIN_MENU_TEXT,
  },
}));

interface IPprops {
  onBannerCloseIconClick: Function;
  onBannerAddClick: Function;
  originComp: string;
}

function ExtensionUpsale({ onBannerCloseIconClick, onBannerAddClick, originComp }: IPprops) {
  const classes = useStyles();
  const isFirebaseInitiated = useSelector(
    (rootState: RootState) => rootState.common?.isFirebaseInitiated
  );
  const [showExtensionUpsellFirbase, setShowExtensionUpsellFirbase] = useState(false);

  const trackActionCalls = (actionName: string) => {
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  const onCloseIconClick = () => {
    onBannerCloseIconClick();
    trackActionCalls('closedExtensionUpsellBanner');
  };

  /*
    We receive the state from the firebase using originComp (from props)
    and show it to the users accordingly.
    To hide/show the UpsellBanner,
    there must be a value in firebase config (extensionUpsellConfig) with the same name as originComp.
  */
  const extensionUpsellFirebaseListener = () => {
    if (window.firebase && window.firebase?.apps?.length) {
      window.firebase
        .database()
        ?.ref('extensionUpsellConfig')
        .on('value', (snapshot: any) => {
          try {
            const data = snapshot.val();
            const extensionUpsellConfig = { ...data };
            setShowExtensionUpsellFirbase(extensionUpsellConfig[originComp]);
          } catch (e) {
            logger('FirebaseExtensionUpsellConfig', e);
          }
        });
    }
  };

  useEffect(() => {
    trackActionCalls('showedExtensionUpsellBanner');
  }, []);

  useEffect(() => {
    extensionUpsellFirebaseListener();
  }, [isFirebaseInitiated]);

  return (
    <Collapse in={showExtensionUpsellFirbase}>
      <Paper elevation={3} className={classes.extensionUpsalePaper}>
        <Grid container alignItems="center">
          <Grid item className={`${classes.content} ${classes.leftContent}`}>
            QuillBot for Chrome
          </Grid>
          {/* <Grid item className={classes.pipe} /> */}
          <Grid
            item
            className={`${classes.content} ${classes.rightContent}`}
            style={{ flexGrow: 1 }}
          >
            Write like a pro, everywhere you write.
          </Grid>

          <AddToChrome originComp={originComp} onAddClick={onBannerAddClick} variant="outlined" />

          <IconButton className={classes.closeIconButton} onClick={onCloseIconClick}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Grid>
      </Paper>
    </Collapse>
  );
}

export default ExtensionUpsale;
